













































import {
    Vue,
    Component
} from "@/shared/vuepack";
import SettingsHeader from "@/employee/components/settings/SettingsHeader.vue";
import SettingsNavigation from "@/employee/components/settings/SettingsNavigation.vue";
import Widget from "@/shared/components/Widget.vue";
import { useWexDebitCardsStore } from "@/shared/store/wexDebitCards";
@Component({
    components: {
        SettingsHeader,
        SettingsNavigation,
        Widget
    }
})
export default class WexDebitCards extends Vue {
    wexDebitCardsStore = useWexDebitCardsStore();

    mounted (): void {
        this.wexDebitCardsStore.getWexDebitCards();
    }

    tableFields = [
        {
            key: "firstName",
            label: "Name"
        },
        {
            key: "cardNumberLast4",
            label: "Card Number"
        },
        {
            key: "cardStatus",
            label: "Card Status"
        },
        {
            key: "isPinSet",
            label: "Pin Status"
        },
        {
            key: "actions",
            label: ""
        }
    ];
}

